(function() {
    'use strict';
    angular
        .module('gwApp')
        .factory('Project', Project);

    Project.$inject = ['$resource'];

    function Project ($resource) {
        var resourceUrl =  'api/projects/:path/:id';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true,
                params: {
                    path: 'page'
                }
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAll': {
                method:'GET',
                isArray: true
            } ,
            'delete':{method:'DELETE'},
            'create': { method:'POST' } ,
            'update': { method:'PUT' },
            'detail': {method:'GET'},
            'submit': {
                method:'GET',
                params: {
                    path: 'submit'
                }
            },
            'approve': {
                method:'GET',
                params: {
                    path: 'approve'
                }
            },
            'reject': {
                method:'GET',
                params: {
                    path: 'reject'
                }
            },
            'cancel': {
                method:'GET',
                params: {
                    path: 'cancel'
                }
            },
            'close': {
                method:'GET',
                params: {
                    path: 'close'
                }
            },
            'order': {
                method:'PUT',
                params: {
                    path: 'order'
                }
            },
            'upload': {
                method:'GET',
                params: {
                    path: 'upload'
                }
            },
            'download': {
                method:'GET',
                params: {
                    path: 'download'
                }
            },
            'getThirdPartyProductByNumber': {
                method: 'GET',
                params: {
                    path: 'getThirdPartyProductByNumber'
                }
            }
        });
    }
})();
